import React, { useEffect, useState } from 'react'
import './SosSearch.scss'
import SearchView from './SearchView'
import RecordDetailDrawer from '../../Applicants/partial/Tabs/SecretaryOfState/RecordDetailDrawer';
import { reset } from 'redux-form'
import { useDispatch } from 'react-redux'
import { dispatchSosRecord } from 'actions/applicants'
import { saveSosRecord } from 'actions/applicants'
import { Toast } from 'components/shared/Toaster'

const SosSearch = ({ isQuickSearch, applicantId = '', updateSummaryCard, closeDrawer, creditCosts }) => {

    const [result, setResult] = useState({}) // search result
    const [isRecordDrawerVisible, setIsRecordDrawerVisible] = useState(false) // record drawer visibility
    const dispatch = useDispatch()

    const handleViewResult = (data) => {
        if (isQuickSearch) {
            dispatchSosRecord(data)(dispatch)
            dispatch(reset('QuickSearch'))
        }
        setResult(data)
        setIsRecordDrawerVisible(true)
    }

    const handleSaveRecord = (setActionLoading) => {
        const sosId = result.sosId ?? result.taxPayerNumber
        const payload = {
            sosSearchId: result.sosSearchId,
            sosId: sosId,
            byAgent: result.relationType === 'byAgent' || false,
            byOfficer: result.relationType === 'byOfficer' || false
        }
        saveSosRecord({ applicationId: applicantId, payload })()
            .then(res => {
                Toast({ type: "success", message: res?.message })
                if (!isQuickSearch){
                    updateSummaryCard()
                    // Trigger saved records refresh
                    window.dispatchEvent(new Event('refreshSavedRecords'))
                }
                // Close the record detail drawer, but keep the main SOS drawer open
                setIsRecordDrawerVisible(false)
                // Don't call closeDrawer() here - let user see the updated list
            })
            .catch(() => {
                setActionLoading(false)
            })
    }

    useEffect(() => {
        return () => {
            if (isQuickSearch) dispatch(reset('QuickSearch'))
        }
        // eslint-disable-next-line
    }, [])

    return (
        <div className={`${!isQuickSearch ? 'm-3' : ''}`}>
            <SearchView viewResult={handleViewResult} isQuickSearch={isQuickSearch} applicantId={applicantId} creditCosts={creditCosts}/>
            <RecordDetailDrawer
                openDrawer={isRecordDrawerVisible}
                setOpenDrawer={setIsRecordDrawerVisible}
                recordInfo={result}
                isQuickSearch={isQuickSearch}
                handleSaveRecord={!isQuickSearch ? handleSaveRecord : null}
            />
        </div>
    )
}

export default SosSearch